import { useState } from "react";
import { ChevronLeft, ChevronRight, Award } from "lucide-react";

const WD = ["M", "T", "W", "T", "F", "S", "S"];

export function StreakCalendar({ days = [] }) {
  const [cursor, setCursor] = useState(() => {
    const d = new Date();
    return new Date(d.getFullYear(), d.getMonth(), 1);
  });
  const set = new Set(days);
  const y = cursor.getFullYear();
  const m = cursor.getMonth();
  const offset = (new Date(y, m, 1).getDay() + 6) % 7;
  const count = new Date(y, m + 1, 0).getDate();
  const p = (n) => String(n).padStart(2, "0");
  const todayKey = (() => { const t = new Date(); return `${t.getFullYear()}-${p(t.getMonth() + 1)}-${p(t.getDate())}`; })();
  const cells = [...Array(offset).fill(null), ...Array.from({ length: count }, (_, i) => i + 1)];
  return (
    <div data-testid="streak-calendar">
      <div className="mb-4 flex items-center justify-between">
        <button className="btn-ghost !px-3" onClick={() => setCursor(new Date(y, m - 1, 1))} aria-label="Previous month" data-testid="calendar-prev-month"><ChevronLeft size={18} /></button>
        <p className="font-heading text-lg text-bt-heading" data-testid="calendar-month-label">{cursor.toLocaleString(undefined, { month: "long", year: "numeric" })}</p>
        <button className="btn-ghost !px-3" onClick={() => setCursor(new Date(y, m + 1, 1))} aria-label="Next month" data-testid="calendar-next-month"><ChevronRight size={18} /></button>
      </div>
      <div className="grid grid-cols-7 gap-1.5 text-center text-xs font-semibold text-bt-sagedeep">
        {WD.map((d, i) => <span key={`wd-${i}-${d}`} className="py-1">{d}</span>)}
        {cells.map((d, i) => {
          if (!d) return <span key={`pad-${i}`} />;
          const key = `${y}-${p(m + 1)}-${p(d)}`;
          const done = set.has(key);
          return (
            <span key={key} data-testid={done ? `calendar-day-done-${key}` : undefined}
              className={`flex aspect-square items-center justify-center rounded-full text-sm ${done ? "bg-bt-primary font-bold text-bt-bg" : "text-bt-text"} ${key === todayKey && !done ? "ring-2 ring-bt-primary" : ""}`}>
              {d}
            </span>
          );
        })}
      </div>
    </div>
  );
}

export function Milestones({ milestones = [], longest = 0 }) {
  return (
    <div className="flex flex-wrap gap-2" data-testid="streak-milestones">
      {milestones.map((ms) => {
        const hit = longest >= ms.days;
        return (
          <div key={ms.days} title={ms.message} data-testid={`milestone-${ms.days}`}
            className={`flex items-center gap-2 rounded-full border px-4 py-2 text-sm ${hit ? "border-bt-primary bg-bt-primary text-bt-bg" : "border-bt-border text-bt-sagedeep"}`}>
            <Award size={14} /> <span className="font-semibold">{ms.days}</span> <span className="hidden sm:inline">{ms.title}</span>
          </div>
        );
      })}
    </div>
  );
}
